import React, { useState, useEffect } from 'react';
import '../styles/navbar.css';
import ThemeToggle from './ThemeToggle';
import MFACodeModal from "./MFACodeModal";
import {useNavigate} from "react-router-dom";

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showMfa, setShowMfa] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <div className="logo-container">
                    <div className="logo">
                        <svg viewBox="0 0 24 24" width="32" height="32">
                            <path fill="url(#logo-gradient)" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                            <defs>
                                <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="var(--primary-color)" />
                                    <stop offset="100%" stopColor="var(--secondary-color)" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <span className="logo-text">Intellommerce</span>
                    {/*
                    <div className="logo">
                        <img src="/logo192.png" alt="Intellommerce Logo"/>
                    </div>
                    <span className="logo-text">Intellommerce</span>
                    */}
                </div>

                <div className="nav-right">
                    <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
                        <a href="#" onClick={() => setMobileMenuOpen(false)}>Home</a>
                        <a onClick={() => {
                            setMobileMenuOpen(false);
                            document.getElementById('features').scrollIntoView({behavior: 'smooth'})
                        }}>Our Process</a>
                        <a onClick={() => {
                            setMobileMenuOpen(false);
                            document.getElementById('services').scrollIntoView({behavior: 'smooth'})
                        }}>Services</a>
                        {/*<a href="#case-studies" onClick={() => setMobileMenuOpen(false)}>Case Studies</a>
                        <a href="#testimonials" onClick={() => setMobileMenuOpen(false)}>Testimonials</a>*/}
                        <a onClick={() => {
                            setMobileMenuOpen(false);
                            document.getElementById('pricing').scrollIntoView({behavior: 'smooth'})
                        }}>Pricing</a>
                        <a onClick={() => {
                            setMobileMenuOpen(false);
                            document.getElementById('contact-form').scrollIntoView({behavior: 'smooth'})
                        }}>Contact</a>
                        <a onClick={() => {
                            setMobileMenuOpen(false);
                            setShowMfa(true)
                        }}>Billing</a>
                    </div>

                    <div className="navbar-actions">
                        <ThemeToggle/>
                        <button className="cta-button" onClick={() => document.getElementById('contact').scrollIntoView({behavior: 'smooth'})}>Get Started</button>
                        <button
                            className="mobile-menu-btn"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle mobile menu"
                        >
                            {mobileMenuOpen ? (
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                                </svg>
                            ) : (
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>
            {showMfa && <MFACodeModal isOpen={showMfa}
                                      onClose={() => {
                                          setShowMfa(false);
                                          navigate('/')
                                          setTimeout(() => {
                                              const element = document.getElementById('hero');
                                              if (element) {
                                                  element.scrollIntoView({
                                                      behavior: 'smooth',
                                                      block: 'start'
                                                  });
                                              }
                                          }, 100);
                                      }}/>}
        </nav>
    );
};

export default Navbar;